document.addEventListener('DOMContentLoaded', () => {
  const initShippingThreshold = () => {
    const thresholdAmount = window.freeShippingThreshold || 50000; // dynamic threshold in cents

    // Shopify.formatMoney might not always be instantly available if base.js loads later, 
    // but the cart update event happens after.
    const formatMoney = (cents) => {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    };

    const updateMsg = (cartTotal) => {
      const nodes = document.querySelectorAll('.shipping_threshold');
      console.log('Shipping Threshold Nodes:', nodes);

      nodes.forEach(node => {
        let currentThreshold = thresholdAmount;
        if (node.dataset.threshold) {
          currentThreshold = parseInt(node.dataset.threshold, 10);
        }

        const remaining = currentThreshold - cartTotal;
        const formattedRemaining = formatMoney(remaining);
        const unlockedMsg = node.dataset.unlockedMessage;

        // Find prefix if it exists in the same container
        const parent = node.closest('.fnt-body, .drawer-heading, .shipping-estimate');
        const prefix = parent ? parent.querySelector('.shipping-threshold-prefix') : null;


        if (remaining > 0) {
          if (node.dataset.amountOnly === 'true') {
            if (prefix) prefix.style.display = '';
            node.innerHTML = `<strong class="text-label-bg-color">${formattedRemaining}</strong>`;
          } else {
            if (prefix) prefix.style.display = 'none';
            if (cartTotal === 0) {
               node.innerHTML = `FREE next day delivery on orders over <strong class="text-label-bg-color">${formattedRemaining}</strong>`;
            } else {
               node.innerHTML = `Spend <strong class="text-label-bg-color">${formattedRemaining}</strong> for free next day delivery`;
            }
          }
        } else {
          if (prefix) prefix.style.display = 'none';
          node.innerHTML = `${unlockedMsg}`;
        }
      });
    };

    const fetchCartAndUpdate = () => {
      fetch(`${window.Shopify.routes.root || '/'}cart.js`)
        .then(response => response.json())
        .then(cart => {
          updateMsg(cart.total_price);
        })
        .catch(err => console.error('Error fetching cart:', err));
    };

    fetchCartAndUpdate(); // initial load

    // Listen to theme's cart change event
    document.addEventListener('action:cart:updateCart', () => {
      fetchCartAndUpdate();
    });

    // Also listen to general change just in case
    document.addEventListener('cart:updated', () => {
      fetchCartAndUpdate();
    });
  };

  initShippingThreshold();
});
